import { Menu, Transition } from "@headlessui/react";
import { ProfileMenu } from "../iconComponents/IcProfileMenu";
import { Fragment } from "react";
import { ProfileIcon } from "../iconComponents/IcProfile";
import iconPenEdit from "../../../assets/svg/pen-icon-edit-profile-user.svg";
import passwordImg from "../../../assets/images/password.svg";
import iconExitEdit from "../../../assets/svg/exit-icon-edit-profile-user.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { appSetModal } from "store/actions/appAction";
import IcArrow from "../iconComponents/IcArrow";

export function ProfileDropdown({ name, role, version }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <div className="text-right">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex justify-center w-full py-2 text-sm font-medium text-white bg-white rounded-md hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <div className="flex flex-row items-center justify-center px-4">
              <ProfileMenu />
              <div className="pr-1">
                <IcArrow />
              </div>
            </div>
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg left-2 w-44 ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="">
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={
                      "group  min-h-[80px] flex flex-row w-full items-center rounded-t-md px-2 py-2 text-sm bg-[#E9F2FF]  "
                    }
                  >
                    <div className="flex items-center justify-center w-10 h-10 bg-white rounded-full">
                      <ProfileIcon />
                    </div>
                    <div className="flex flex-col justify-between flex-1 px-3 ">
                      <span className="text-sm font-normal text-right text-black text">{name}</span>
                      {role && (
                        <span className="text-xs text font-normal text-[#878787] text-right pt-1 ">
                          {role}
                        </span>
                      )}
                    </div>
                  </button>
                )}
              </Menu.Item>
            </div>
            <div>
              {/*<Menu.Item>*/}
              {/*  {({ active }) => (*/}
              {/*    <button*/}
              {/*      className={`${*/}
              {/*        active ? "bg-blue-100 text-gray-900" : "text-gray-900"*/}
              {/*      } group flex w-full items-center px-2  text-sm  bg-white`}*/}
              {/*      onClick={(e) => {*/}
              {/*        navigate("./profile");*/}
              {/*      }}*/}
              {/*    >*/}
              {/*      <div className="flex items-center justify-center w-10 h-10 rounded-full">*/}
              {/*        <img src={iconPenEdit} alt="iconPenEdit" />*/}
              {/*      </div>*/}
              {/*      <div className="flex flex-col items-center flex-1 px-3 ">*/}
              {/*        <span className="text-sm text font-normal text-[#6F6F6F] text-right">*/}
              {/*          ویرایش پروفایل*/}
              {/*        </span>*/}
              {/*      </div>*/}
              {/*    </button>*/}
              {/*  )}*/}
              {/*</Menu.Item>*/}
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? "bg-blue-100 text-gray-900" : "text-gray-900"
                    } group flex w-full items-center px-2  text-sm  bg-white`}
                    onClick={() =>
                      dispatch(
                        appSetModal(
                          {
                            component: "change-password",
                            title: "تغییر رمز عبور",
                            closeButton: true,
                          },
                          true
                        )
                      )
                    }
                  >
                    <div className="flex items-center justify-center w-10 h-10 rounded-full">
                      <img src={passwordImg} alt="iconPenEdit" />
                    </div>
                    <div className="flex flex-col items-center flex-1 px-3 ">
                      <span className="text-sm text font-normal text-[#6F6F6F] text-right">
                        تغییر رمز عبور
                      </span>
                    </div>
                  </button>
                )}
              </Menu.Item>
            </div>
            <div>
              {/* <Menu.Item>
                {({ active }) => (
                  <button
                    className={
                      "group flex w-full items-center rounded-md px-2 py-2 text-sm  bg-white"
                    }
                  >
                    Delete
                  </button>
                )}
              </Menu.Item> */}
              <Menu.Item>
                {({ active }) => (
                  <a
                    href="/auth/logout"
                    className={
                      "group flex flex-col w-full items-center rounded-b-md px-2 py-2 text-sm bg-[#F4F4F4] "
                    }
                  >
                    <div className="flex flex-row items-center w-full">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full">
                        <img src={iconExitEdit} alt="exit-icon" />
                      </div>
                      <div className="flex flex-col justify-between flex-1 px-3 ">
                        <span className="text-sm text font-normal text-[#CB0B0B] text-right">
                          خروج از حساب
                        </span>
                      </div>
                    </div>
                    {version && (
                      <span className="text-xs text font-normal text-[#878787] text-right pt-1 ">
                        {version}
                      </span>
                    )}
                  </a>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
